import styled from 'styled-components'
import Button from '@material-ui/core/Button'

export const DefaultButton = styled(Button)`
  background: #F05A28 !important;
  color: white !important;
  margin: auto 0;
  font-family: CirceBold !important;
  font-size: 18px !important;
  opacity: ${p => p.disabled ? .5 : 1};
  line-height: 24px !important;
`

export const ChatButton = styled.button`
  color: white;
  background: ${props => props.color || 'transparent'};
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all .3s ease-in-out;
  &:hover {
    transition: all .3s ease-in-out;
    border: 1px solid rgba(255, 255, 255, 1);
  }
  border-radius: 20px;
  padding: 10px 25px;
  margin: 0 auto;
  cursor: pointer;
`